<template>
  <div class="container-fluid pb-5 pt-4 px-4">
    <h5 class="font-weight-light mb-1">
      <b>Escolha o plano de registro</b>
    </h5>
    <p class="text-muted mb-4">Selecione o plano ideal para o cliente.</p>
    <hr class="mt-1 mb-4" />

    <div class="row justify-content-center">

      <!-- STARTER -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="plano-card" :class="{ selecionado: planoSelecionado === 'starter' }" @click="planoSelecionado = 'starter'">
          <div class="d-flex align-items-center mb-3">
            <div class="check-box mr-3" :class="{ ativo: planoSelecionado === 'starter' }">
              <i v-if="planoSelecionado === 'starter'" class="fas fa-check"></i>
            </div>
            <div>
              <div class="plano-tipo">Registro</div>
              <div class="plano-nome">Starter</div>
            </div>
          </div>

          <div class="row no-gutters features-grid">
            <div class="col-6" v-for="(feat, i) in features" :key="i">
              <div class="feature-item" :class="{ inativo: !starterFeatures.includes(feat.key) }">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="feature-icon"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>{{ feat.label }}</span>
              </div>
            </div>
          </div>

          <div class="preco-area text-center mt-3">
            <div class="preco-de">De: <s>R$ 19,90</s> <span class="badge-desconto">15% off</span></div>
            <div class="preco-por">
              <span class="preco-rs">R$</span><span class="preco-valor">9</span><span class="preco-centavos">,90/mês</span>
            </div>
          </div>
        </div>
      </div>

      <!-- PREMIUM -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="plano-card" :class="{ selecionado: planoSelecionado === 'premium' }" @click="planoSelecionado = 'premium'">
          <div class="d-flex align-items-center mb-3">
            <div class="check-box mr-3" :class="{ ativo: planoSelecionado === 'premium' }">
              <i v-if="planoSelecionado === 'premium'" class="fas fa-check"></i>
            </div>
            <div>
              <div class="plano-tipo">Registro</div>
              <div class="plano-nome">Premium</div>
            </div>
          </div>

          <div class="row no-gutters features-grid">
            <div class="col-6" v-for="(feat, i) in features" :key="i">
              <div class="feature-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="feature-icon"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>{{ feat.label }}</span>
              </div>
            </div>
          </div>

          <div class="preco-area text-center mt-3">
            <div class="preco-de">De: <s>R$ 49,90</s> <span class="badge-desconto">15% off</span></div>
            <div class="preco-por">
              <span class="preco-rs">R$</span><span class="preco-valor">29</span><span class="preco-centavos">,90/mês</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-2">
      <b-button
        variant="success"
        size="lg"
        :disabled="!planoSelecionado || loading"
        class="px-5"
        @click="confirmarPlano"
      >
        <span v-if="loading">
          <b-spinner small class="mr-2" />Confirmando...
        </span>
        <span v-else>Confirmar plano</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import captureError from "../../helpers/captureError";
import config from "../../config";

export default {
  data() {
    return {
      loading: false,
      planoSelecionado: null,
      planosIds: {
        starter: 'fbfcf99f-2a25-4224-bb46-76b9c85bc741',
        premium: '40f2fa99-ab2c-40a3-9206-8c8640c8253a',
      },
      planosInfo: {
        starter: { label: 'Starter', preco: 'R$9,90/mês' },
        premium: { label: 'Premium', preco: 'R$29,90/mês' },
      },
      features: [
        { key: "registro_bike",              label: "Registro da bike",              icon: "fa-bicycle"       },
        { key: "certificado_transferencia",  label: "Certificado de transferência",  icon: "fa-file-alt"      },
        { key: "reboque_bike",               label: "Reboque da bike",               icon: "fa-truck"         },
        { key: "assistencia_24h",            label: "Assistência 24h",               icon: "fa-headset"       },
        { key: "transporte_ciclista",        label: "Transporte ciclista",           icon: "fa-shuttle-van"   },
        { key: "selo_identificacao",         label: "Selo de identificação",         icon: "fa-qrcode"        },
        { key: "documento_digital",          label: "Documento digital",             icon: "fa-file-pdf"      },
        { key: "revisao_bike",               label: "Revisão da bike",               icon: "fa-tools"         },
        { key: "personal_fit",               label: "Personal fit",                  icon: "fa-dumbbell"      },
        { key: "chaveiro",                   label: "Chaveiro",                      icon: "fa-key"           },
        { key: "bike_box",                   label: "Bike box",                      icon: "fa-box"           },
        { key: "reparo_bike",                label: "Reparo da bike",                icon: "fa-wrench"        },
        { key: "nutricao_esportiva",         label: "Nutrição esportiva",            icon: "fa-apple-alt"     },
        { key: "manutencao_bike",            label: "Manutenção da bike",            icon: "fa-cogs"          },
        { key: "bike_fit",                   label: "Bike fit",                      icon: "fa-biking"        },
        { key: "treino_ciclista",            label: "Treino de ciclista",            icon: "fa-running"       },
        { key: "treinamento_fortalecimento", label: "Treinamento de fortalecimento", icon: "fa-fist-raised"   },
        { key: "cashback",                   label: "Cashback em lojas parceiras",   icon: "fa-store"         },
        { key: "bike_vantagens",             label: "Bike vantagens",               icon: "fa-star"          },
      ],
      starterFeatures: [
        "registro_bike",
        "certificado_transferencia",
        "reboque_bike",
        "assistencia_24h",
        "transporte_ciclista",
        "selo_identificacao",
        "documento_digital",
        "bike_vantagens",
      ],
    };
  },
  methods: {
    async confirmarPlano() {
      this.loading = true;
      try {
        const response = await axios.post(`${config.API_URLV2}/AssinaturaRegistro/FinalizarSemCobranca`, {
          IdPlano: this.planosIds[this.planoSelecionado],
          IdCliente: this.$route.params.clienteId,
        });

        const data = response.data;
        const linkPagamento = data.urlPagamento;
        const info = this.planosInfo[this.planoSelecionado];

        this.$router.push({
          name: "registro-sucesso",
          params: {
            planoNome: info.label,
            planoPreco: info.preco,
            clienteNome: this.$route.params.clienteNome || "cliente",
            linkPagamento,
          },
        });
      } catch (error) {
        captureError(error);
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível confirmar o plano. Tente novamente.",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#d33",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.plano-card {
  border: 2px solid #e0e0e0;
  border-radius: 16px;
  padding: 24px 20px 20px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: #fff;
  height: 100%;
}

.plano-card:hover {
  border-color: #73b329;
}

.plano-card.selecionado {
  background: #4B9C2E;
  border-color: #4B9C2E;
  color: #fff;
}

.check-box {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 2px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
  color: #fff;
}

.check-box.ativo {
  background: #4B9C2E;
  border-color: #4B9C2E;
}

.plano-card.selecionado .check-box.ativo {
  background: #fff;
  border-color: #fff;
  color: #4B9C2E;
}

.plano-tipo {
  font-size: 0.8rem;
  color: #888;
  line-height: 1;
}

.plano-card.selecionado .plano-tipo {
  color: rgba(255,255,255,0.75);
}

.plano-nome {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a3c6e;
  line-height: 1.1;
}

.plano-card.selecionado .plano-nome {
  color: #fff;
}

.features-grid {
  margin-bottom: 4px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #333;
  padding: 4px 2px;
  line-height: 1.3;
}

.plano-card.selecionado .feature-item {
  color: #fff;
}

.feature-item.inativo {
  color: #bbb;
  font-weight: 400;
}

.feature-icon {
  margin-top: 2px;
  color: #4B9C2E;
  flex-shrink: 0;
}

.feature-item.inativo .feature-icon {
  color: #ccc;
}

.plano-card.selecionado .feature-icon {
  color: #fff;
}

.plano-card.selecionado hr {
  border-color: rgba(255,255,255,0.35);
}

.confira-link {
  color: #4B9C2E;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  display: block;
}

.confira-link:hover {
  text-decoration: underline;
}

.plano-card.selecionado .confira-link {
  color: #fff;
}

.preco-area {
  min-height: 60px;
}

.preco-gratuito {
  font-size: 1.7rem;
  font-weight: 700;
  color: #1a3c6e;
}

.plano-card.selecionado .preco-gratuito {
  color: #fff;
}

.preco-de {
  font-size: 0.82rem;
  color: #888;
}

.plano-card.selecionado .preco-de {
  color: rgba(255,255,255,0.8);
}

.badge-desconto {
  background: #e0e0e0;
  color: #555;
  border-radius: 20px;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 600;
}

.preco-por {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  line-height: 1;
  color: #1a3c6e;
}

.plano-card.selecionado .preco-por {
  color: #fff;
}

.preco-rs {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.preco-valor {
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 1;
}

.preco-centavos {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 4px;
}
</style>
